import {
    ExtendedApartmentBuilding,
    ExtendedConstructionNumber,
    ExtendedPropertyType,
} from './api-utilities.types';

const showPrice = ({
    constructionNumber,
    apartmentBuilding,
    propertyType,
}: {
    constructionNumber?: ExtendedConstructionNumber;
    propertyType?: ExtendedPropertyType;
    apartmentBuilding?: ExtendedApartmentBuilding;
}): boolean => {
    const { status } = constructionNumber || propertyType || apartmentBuilding || {};
    const { salesPrice } = constructionNumber || propertyType || {};

    if (salesPrice) {
        const { priceType } = salesPrice;
        if (priceType === 'PriceOnRequest') return false;
    }

    return !['Rented', 'Sold', 'UnderConstruction'].includes(status || '');
};

export { showPrice };
